import { HTTPError } from "./HTTPError";

export class UnauthorizedError extends HTTPError {}
